import { render, staticRenderFns } from "./alte.vue?vue&type=template&id=8f249194&scoped=true&"
import script from "./alte.vue?vue&type=script&lang=js&"
export * from "./alte.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f249194",
  null
  
)

export default component.exports